import { Component, Input, OnInit } from '@angular/core';
import { Shape, Sizes, SkeletonSizeBase } from '../../../common';
import { getSizes } from '../../../common/utils/utils';

@Component({
  selector: 'skc-bullet-list',
  templateUrl: './bullet-list.component.html',
  styleUrls: ['./bullet-list.component.less']
})
export class BulletListComponent extends SkeletonSizeBase implements OnInit {
  @Input('skc-shape') shape = Shape.CIRCLE;
  @Input('skc-size') size: Sizes;
  @Input('skc-line-width') lineWidth;
  enumShape = Shape;
  height;
  width;
  constructor() {
    super();
  }

  ngOnInit() {
    this.height = getSizes(this.size);
    this.width = this.height;
  }
}
